export const readOnly = 'read_only';
export const normal = 'normal';
export const quality = 'quality';
